import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef, Inject,
    Input,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {INodeOptions} from "@app/workflow-common/diagram-view2/models/node.model";
import {DiagramService} from "@app/workflow-common/diagram-view2/services/diagram.service";
import {combineLatest, Subject, Subscription} from "rxjs";
import {first, takeUntil} from "rxjs/operators";
import {SidepanelModalService} from "@app/sidepanel/services/sidepanel-modal.service";
import {TranslateService} from "@ngx-translate/core";
import {BlockModel, BlockModelInterface, DagSourceModel} from "@app/workflow-common/services/DagSourceModel";
import {AddTaskSidePanelComponent} from "@app/workflow-common/add-task-side-panel/add-task-side-panel.component";
import {
    AddBlockInitialStateInterface
} from "@app/workflow-common/diagram-view2/models/add-block-initial-state.interface";
import {TriggerDatasetService} from "@app/workflow-common/services/trigger-dataset.service";
import {animate, keyframes, state, style, transition, trigger} from "@angular/animations";
import {ConfirmModalConfig} from "@app/interfaces/common-modal-popups";
import {WorkflowhttpService} from "@app/workflow-common/services/workflowhttp.service";
import {
    HistoryTaskStatusModalComponent
} from "@app/workflow-common/diagram-view2/panels/history-task-status-modal/history-task-status-modal.component";
import {DOCUMENT} from "@angular/common";

const objectNameDisplayContent = {
    'customFields': 'Custom fields'
};

@Component({
    selector: 'app-node',
    animations: [
        trigger('highlightNodeAdded', [
            transition('*=>on', animate('3000ms', keyframes([
                style({backgroundColor: '#ffffff', offset: 0} ),
                style({backgroundColor: '#DAFDD7', offset: 0.1} ),
                style({backgroundColor: '#ffffff', offset: 1} ),
            ])))
        ])
    ],
    templateUrl: './node.component.html',
    styleUrls: ['./node.component.scss'],
    host: {
      class: 'cs-d-flex align-items-center',
    },
    styles: ['.wf-diagram-block-box { display: flex; align-items: center}'],
})
export class NodeComponent implements OnInit, OnDestroy, AfterViewInit {

    @Input() parentNode: any;
    @Input() node: any;
    @Input() hasParent = false;
    @Input() direction: 'vertical' | 'horizontal' = 'vertical';
    @Input() dagSourceModel: DagSourceModel;
    @Input() index: number = undefined;
    @Input() isNew: boolean = false;

    @Input() id: string;
    @Input() parentId: string;
    @Input() name: string;
    @Input() isConditional: boolean = false;
    @Input() block_name: string;
    @Input() blockId: string = '';
    @Input() model: any = undefined;
    @Input() key: string;
    @Input() children: BlockModelInterface[] = [];
    @Input() condition: {
        col_name: string,
        operator: string,
        fieldType?: null|string,
        pageType: string,
        text: string,
        type: string,
        value: any,
    } = undefined;
    @Input() screenName: string;

    //cs initializer

    @ViewChild('emailBlock') emailBlockTemplate: TemplateRef<any>;
    @ViewChild('smsBlock') smsBlockTemplate: TemplateRef<any>;
    @ViewChild('notificationBlock') notificationBlockTemplate: TemplateRef<any>;
   // @ViewChild('officeTaskBlock') officeTaskBlockTemplate: TemplateRef<any>;
    @ViewChild('delayBlock') delayBlockTemplate: TemplateRef<any>;
    @ViewChild('dummyBlock') dummyBlockTemplate: TemplateRef<any>;
    @ViewChild('addJobBlock') addjobBlockTemplate: TemplateRef<any>;
    @ViewChild('conditionalBlock') conditionalBlockTemplate: TemplateRef<any>;
    @ViewChild('conditionalDelayBlock') conditionalDelayBlockTemplate: TemplateRef<any>;
    @ViewChild('elseBlock') elseBlockTemplate: TemplateRef<any>;
    @ViewChild('setCustomFieldBlock') setCustomFieldBlockTemplate: TemplateRef<any>;
    @ViewChild('scheduledActivityBlock') scheduledActivityBlockTemplate: TemplateRef<any>;
    @ViewChild('sendJobReportBlock') sendJobReportBlockTemplate: TemplateRef<any>;
    @ViewChild('startSequenceBlock') startSequenceBlockTemplate: TemplateRef<any>;
    @ViewChild('setSalesPersonBlock') setSalesPersonBlockTemplate: TemplateRef<any>;
    @ViewChild('sendProposalBlock') sendProposalBlockTemplate: TemplateRef<any>;
    @ViewChild('defaultNodeTemplate') defaultNodeTemplate: TemplateRef<any>;

    @ViewChild('nodeRef') nodeRef: ElementRef;

    iconImageUrl: string = '/images/mx-graph/add.svg';
    nodeOptions: INodeOptions;
    nodeTemplate: TemplateRef<any>;
    blockHeaderText:string = 'What do you want to happen?';
    isRoot: boolean = false;

    modalSubscription: Subscription[] = [];
    operatorsDisplayText: any;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    emailBlockDisplay = {
        subject: '',
        toEmailTag: '',
        ccEmailTag: '',
        bccEmailTag: '',
    };

    sendJobReportDisplay = {
        templateName: '',
        toEmailTag: '',
    };
    setCustomFieldDisplay={
        templateFieldToGet:'',
        customFieldToSet:''
    }

    smsBlockDisplay = {
        title: '',
        toAddress: '',
    };

    notificationBlockDisplay = {
        roles: '',
        message: ''
    };

    delayBlockDisplay = {
        interval: '',
        unit: ''
    };
    startSequenceBlockDisplay = {
        sequenceName: '',
        sequenceSentTo: ''
    };
    setSalesPersonBlockDisplay = {
        AssignTo : ''
    };
    sendProposalBlockDisplay = {
        subject: '',
        toEmailTag: '',
        templateName: ''
    };
    conditionalDelayBlockDisply: string = '';
    addJobBlockDisply: string = '';

    scheduledActivityBlockDisplay = {
        iconClassNames: {
            'Call': 'fa fa-phone',
            'Email': 'fa fa-envelope',
            'Meeting': 'fas fa-calendar-alt',
            'Task': 'fa fa-list-ul'
        },
        description: '',
        activityType: '',
        activityIcon: '',
        dueDate: '',
        assignTo: '-',
        assigneeIds: [],
    }

    subscriptions: Subscription[] = [];
    deleteMessage: string = 'This will delete this block and all the following blocks in this workflow.';
    onHighlight: string = '';
    statusConfirmationModalConfig: ConfirmModalConfig;
    highlighDeletableNode: boolean = false;
    viewMode: string | 'audit' | 'history' | 'form' = 'form';
    taskStatus: object = {};
    isAuditHightlight: boolean = false;

    constructor(
        protected modalService: SidepanelModalService,
        protected changeDetection: ChangeDetectorRef,
        protected _diagramService: DiagramService,
        protected _translateService: TranslateService,
        protected triggerService: TriggerDatasetService,
        @Inject('confirmationBoxHelper') protected confirmationBoxHelper,
        @Inject('$scope') protected ajsScope,
        protected _workflowHttp: WorkflowhttpService,
        @Inject(DOCUMENT) protected document: Document,
    ) { }

    ngOnInit() {
        //
        this.isRoot = this.id == 'cs_initializer';
        this.block_name = this.name;

        this.operatorsDisplayText = this.triggerService.getOperatorsDisplayText();
        combineLatest(
            this._diagramService.diagram$,
            this._diagramService.markDeletableNodes$
        )
        .pipe( takeUntil(this._unsubscribeAll))
        .subscribe( ([nodeParams, blockId]) => {
            const {nodeOptions} = nodeParams;
            this.nodeOptions = nodeOptions;
            this.viewMode = this.nodeOptions.viewMode;
            if(this.viewMode == 'history' && this.nodeOptions.tasksStatus && this.nodeOptions.tasksStatus.hasOwnProperty(this.blockId)) {
                this.taskStatus = this.nodeOptions.tasksStatus[this.blockId];
            }
            if(this.viewMode == 'audit') {
                this.isAuditHightlight = this.nodeOptions.audit['taskId'].includes(this.blockId);
            }
            if(blockId == this.blockId) {
                //this.highlighDeletableNode = true;
            }
        });

        this.formatter();
        this.setTemplate();
        this.setConfirmationModalConfig();

    }

    formatter() {
        if(this.condition) {

        }
        if(this.name == 'emailBlock') {
            const {subject, toEmailTag, ccEmailTag, bccEmailTag} = this.model;
            this.emailBlockDisplay.subject = subject.replace(/(<([^>]+)>)/gi, "");
            if(Array.isArray(toEmailTag) && toEmailTag.length ) {
                let toTagName = toEmailTag.map( item => item.displayName );
                this.emailBlockDisplay.toEmailTag = toTagName.join(', ');
            }
            if(Array.isArray(ccEmailTag) && ccEmailTag.length ) {
                let ccTagName = ccEmailTag.map( item => item.displayName );
                this.emailBlockDisplay.ccEmailTag = ccTagName.join(', ');
            }
            if(Array.isArray(bccEmailTag) && bccEmailTag.length ) {
                let bccTagName = bccEmailTag.map( item => item.displayName );
                this.emailBlockDisplay.bccEmailTag = bccTagName.join(', ');
            }
        }
        if(this.name == 'smsBlock') {
            const {toSmsTag, title} = this.model;
            if(Array.isArray(toSmsTag) && toSmsTag.length ) {
                let toSmsTagName = toSmsTag.map( item => item.displayName );
                this.smsBlockDisplay.toAddress = toSmsTagName.join(', ');
            }
        }
        if(this.name == 'notificationBlock') {
            const {rolesDisplay, textMessage} = this.model;
            this.notificationBlockDisplay.roles = rolesDisplay.join(', ');
            this.notificationBlockDisplay.message = textMessage;
        }

        if(this.name == 'scheduledActivityBlock') {
            const {description, activityTypeDisplay, scheduleInterval, unit, displayTime, assigneeIds, assigneeDisplay} = this.model;
            let _unit = scheduleInterval == 1 ? unit.slice(0, -1) : unit;
            let dueDateText = 'Current date +'+scheduleInterval +' '+ unit +' at ' + displayTime;
            this.scheduledActivityBlockDisplay.description = description;
            this.scheduledActivityBlockDisplay.activityType = activityTypeDisplay;
            this.scheduledActivityBlockDisplay.activityIcon = this.scheduledActivityBlockDisplay.iconClassNames[activityTypeDisplay];
            this.scheduledActivityBlockDisplay.dueDate = dueDateText;
            this.scheduledActivityBlockDisplay.assignTo = assigneeIds.length > 0 ? assigneeDisplay.join(', ') : '-';
        }

        if(this.name == 'delayBlock') {
            const { interval, unit } = this.model;
            this.delayBlockDisplay.unit =  interval == 1 ? unit.slice(0, -1) : unit;
            this.delayBlockDisplay.interval = interval;
        }

        if(this.name == 'conditionalDelayBlock') {
            const { interval, unit, fieldLabel, event_method } = this.model;
            const conditionalDelayBlockData = this.dagSourceModel.getBlocksSource().getBlockByKey(this.key);
            const displayText = conditionalDelayBlockData['displayText'].join('');
            const _unit = interval == 1 ? unit.slice(0, -1) : unit;
            const _eventName = event_method == 'pass on before' ? 'before' : 'after';
            this.conditionalDelayBlockDisply = displayText
                .replace('#interval#', interval)
                .replace('#unit#', _unit)
                .replace('#eventName#', _eventName)
                .replace('#field#', fieldLabel);
        }

        if(this.name == 'addjobBlock') {
            const { displayValue } = this.model;
            this.addJobBlockDisply = displayValue;
        }
        if(this.name == 'setCustomFieldBlock') {
            this.setCustomFieldDisplay.customFieldToSet = this.model.targetDisplayValue;
            this.setCustomFieldDisplay.templateFieldToGet = this.model.sourceDisplayValue;
        }

        if(this.name == 'sendJobReportBlock') {
            const {templateName, toEmailTag} = this.model;
            if(Array.isArray(toEmailTag) && toEmailTag.length ) {
                let toTagName = toEmailTag.map( item => item.displayName );
                this.sendJobReportDisplay.toEmailTag = toTagName.join(', ');
            }
            this.sendJobReportDisplay.templateName = templateName;
        }
        if(this.name == 'startSequenceBlock') {
            const { contactId, templateName } = this.model;
            this.startSequenceBlockDisplay.sequenceName = templateName;
            this.startSequenceBlockDisplay.sequenceSentTo = contactId;
        }
        if(this.name == 'setSalesPersonBlock') {
            const { displayValue } = this.model;
            this.setSalesPersonBlockDisplay.AssignTo = displayValue;
        }
        if(this.name == 'sendProposalBlock') {
            const {subject, toEmailTag, ccEmailTag, bccEmailTag, templateName} = this.model;
            this.sendProposalBlockDisplay.subject = subject.replace(/(<([^>]+)>)/gi, "");
            this.sendProposalBlockDisplay.templateName = templateName;
            if(Array.isArray(toEmailTag) && toEmailTag.length ) {
                let toTagName = toEmailTag.map( item => item.displayName );
                this.sendProposalBlockDisplay.toEmailTag = toTagName.join(', ');
            }
        }
    }

    setConfirmationModalConfig() {
        const { isDraftMode } = this.nodeOptions;
        const confirmBxValidationMsg = isDraftMode ? this._translateService.instant('confirmation.warning.text', { word: 'ACTIVATE', message: 'activate the automation'}) :
            this._translateService.instant('confirmation.warning.text', { word: 'DEACTIVATE', message: 'deactivate the automation'});
        const actionText = isDraftMode ? 'ACTIVATE' : 'DEACTIVATE';
        const warningTxt = isDraftMode ? 'Confirm.Status.Activation.Message' : 'Confirm.Status.Deactivation.Message.Custom';
        const title = isDraftMode ? 'Confirm.Activation' : 'Confirm.Deactivation';
        let helpTxtList = [];
        if(actionText == 'DEACTIVATE'){
            helpTxtList = ['Custom.Automation.Deactivate.Message']
        }

        this.statusConfirmationModalConfig = {
            modalType: 'confirm',
            actionText,
            confirmBtnType: 'DEFAULT',
            confirmBtnText: actionText,
            confirmBxValidationMsg,
            itemText: "Automation",
            showModal: false,
            closeText: 'cancel',
            message: { warningTxt, helpTxtList: helpTxtList},
            title,
            doAction: null,
            actionArg: '',
        };
    }

    showHistoryTaskStatus() {
        const taskId = this.isRoot ? this.id : this.blockId;
        const initialState = {
            task: this.nodeOptions.tasksStatus[taskId],
        };
        const modalRef = this.showHideSidePanel(initialState, HistoryTaskStatusModalComponent);
    }

    addNode(isEdit:boolean = false) {
        const { isDraftMode } = this.nodeOptions;
        if(!isDraftMode && !isEdit) {
            this.showConfirmation('The automation must be disabled before add or insert new action. Do you want to deactivate?')
                .then( () => {
                    this.setConfirmationModalConfig();
                    this.statusConfirmationModalConfig.showModal=true;
                    this.statusConfirmationModalConfig.doAction = this.deactivateAutomation.bind(this);
                    this.statusConfirmationModalConfig.actionArg = false;
                }, () => {
                    this.highlighDeletableNode=false;
                });
            return;
        }

        const initialState: AddBlockInitialStateInterface = {
            title: 'Add action automation',
            objectName: this.nodeOptions.objectName,
            objectNameDisplayText: objectNameDisplayContent[this.nodeOptions.objectName],
            nodeOptions: this.nodeOptions,
            dagSourceModel: this.dagSourceModel,
            workflowType: this.nodeOptions.workflowType,
            blockId: this.isRoot ? 'cs_initializer' : this.blockId,
            actionType: '',
            parentId: this.id,
            isActive: false,
            tableTypeId: 1,
            tableTypeName: '',
            isEdit: isEdit,
            hasChildren: this.children.length > 0,
            screenName: this.screenName,
            isElseBlock: this.name === 'elseBlock',
        };
        const addBlockRef = this.showHideSidePanel(initialState, AddTaskSidePanelComponent);
        addBlockRef.content.onClose.subscribe( (blockData: any) => {
            const {action, data} = blockData;
            const node = data;
            if(action === 'save_and_close') {
                if(isEdit) {
                    const {model, condition} =  node
                    this.model = model;
                    if(condition) {
                        this.condition = condition;
                    }
                    this.dagSourceModel.updateTask(this.blockId, node);
                    this.formatter();
                    this.onHighlight='on';
                    this._diagramService.isNodeUpdated();
                    this._diagramService.autoSave(true);
                }
                else {
                    if(node.isConditional && !node.hasOwnProperty('id') && this.children.length == 0) {
                        const {col_name, text, type, fieldType, pageType} = node['condition'];
                        const newElseBlock = new BlockModel({
                            name: 'elseBlock',
                            parentId: this.id,
                            isConditional: true,
                            model: {},
                            key: '',
                            condition: {
                                operator: 'else',
                                value: '',
                                col_name,
                                text,
                                type,
                                fieldType,
                                pageType,
                            }
                        });
                        this.dagSourceModel.addTask(newElseBlock, this.id);
                        this.dagSourceModel.addTask(node, this.id);
                        this._diagramService.addNewNode(this.id, [newElseBlock, node]);
                    }
                    else {
                        if(this.children.length > 0 && this.name != 'conditionalBlock') {
                            const downStreamNodes:any[] = this.children;
                            const insertedBlock = this.dagSourceModel.addTask(node, this.id);
                            const parentId = insertedBlock.id;

                            // switching parentId while inserting node in between
                            downStreamNodes.forEach( _node => {
                                _node.parentId = parentId;
                                this.dagSourceModel.updateTask(_node.blockId, _node);
                            });
                        }
                        else {
                            this.dagSourceModel.addTask(node, this.id);
                        }
                        this._diagramService.addNewNode(this.id, node);
                    }
                    this._diagramService.isNodeUpdated();
                    this._diagramService.autoSave(true);
                }
                addBlockRef.hide();
            }
            else if(action == 'remove_block') {
                const { isDraftMode } = this.nodeOptions;
                if(isDraftMode) {
                    this.highlighDeletableNode=true;
                    const childNodes = this.dagSourceModel.getAllChildren(this.blockId);
                    childNodes.forEach( _blockId => {
                        this._diagramService.markDeletableNodes(_blockId);
                    })
                    this._diagramService.markDeletableNodes(this.blockId);
                }
                addBlockRef.hide();
                const message = !isDraftMode ? 'The automation must be disabled before deleting this action. Do you want to deactivate?'
                    : 'This will delete this block and all the following blocks in this workflow.';
                const confimartion = this.showConfirmation(message);
                confimartion.then( () => {
                    if(!isDraftMode) {
                        this.statusConfirmationModalConfig.showModal=true;
                        this.statusConfirmationModalConfig.doAction = this.deactivateAutomation.bind(this);
                        this.statusConfirmationModalConfig.actionArg = false;
                    }
                    else {
                        this.statusConfirmationModalConfig.showModal=false;
                        this.deleteNode();
                        this._diagramService.isNodeUpdated();
                        this._diagramService.autoSave(true);
                    }
                }, () => {
                    this.highlighDeletableNode=false;
                })
            }
        });
    }

    showConfirmation(message:string): Promise<any> {
        this.deleteMessage = 'The automation must be deactivate before deleting this action. Do you want to deactivate?';
        const { isDraftMode } = this.nodeOptions;
        if(isDraftMode) {
            this.deleteMessage = 'This will delete this block and all the following blocks in this workflow.';
        }
        return this.confirmationBoxHelper.getConfirmation(message, this.ajsScope);
    }

    deactivateAutomation(deactivate, cb) {
        const { workflowId } = this.nodeOptions;
        const automationActivate = {
            workflowId: workflowId,
            status: deactivate
        };
        this._workflowHttp.automationStatusUpdate(workflowId, {automationActivate})
        .subscribe({
            next: resp => {
                if(resp.hasOwnProperty('automationActivate')) {
                    cb('SUCCESS');
                    this.statusConfirmationModalConfig.showModal=false;
                    this.nodeOptions.isDraftMode = true;
                }
            }
        });
    }

    deleteNode() {
        this._diagramService.deleteNode(this.parentId, this.index);
        if(this.condition) {
            const childBlocks: Array<any> = this.dagSourceModel.getChildren(this.parentId);
            if(childBlocks.length == 2) {
                this.dagSourceModel.removeTask(childBlocks[0].blockId);
            }
        }
        this.dagSourceModel.removeTask(this.blockId);

    }

    editNode() {
        if(this.viewMode == 'history') {
            this.showHistoryTaskStatus();
        }
        else if(this.viewMode == 'form') {
            this.addNode(true);
        }
    }

    getValue(colName: string, value: any) {
        const fieldsAsObject = this.dagSourceModel.getFieldMetadata();
        if(!fieldsAsObject[colName]) {
            return '';
        }
        const field = fieldsAsObject[colName];
        if(field.hasOwnProperty('options')) {
            if(Array.isArray(value)) {
                const optionValue = field['options'].filter( i => value.includes( String(i.id) ));
                const multiVal = optionValue.map(t=>t.text);
                if(multiVal.length > 0) {
                    value = multiVal.join(', ');
                }
            }
            else {
                const activeOption = field.options.find( (item) => {
                    return item.id == value;
                });
                if(activeOption) {
                    value = activeOption['text'];
                }
            }
        }
        return value;
    }

    showHideSidePanel(initialState: {} = undefined, Component:any) {
        const _combine = combineLatest(
            this.modalService.onShow,
            this.modalService.onHidden,
        )
        .pipe( takeUntil( this._unsubscribeAll))
        .subscribe( () => this.changeDetection.markForCheck());

        this.modalSubscription.push(
            this.modalService.onShow.subscribe(() => {
            })
        );
        this.modalSubscription.push(
            this.modalService.onHidden.subscribe( () => {
                this.unsubscribe();
            })
        );
        this.modalSubscription.push(_combine);

        return this.modalService.show(Component, {
            initialState,
            'size': 'md',
            'class': 'workflow-sidepanel'
        });
    }

    unsubscribe() {
        this.modalSubscription.forEach( (subscription: Subscription) => {
            subscription.unsubscribe();
        });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
        this.unsubscribe();
    }

    setTemplate() {
        const template = this.name+'Template';
        if(this[template]) {
            this.nodeTemplate = this[template];
        }
        else {
            this.nodeTemplate = this.defaultNodeTemplate;
        }
    }

    stripHtml(html)
    {
        let tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }

    ngAfterContentInit(): void {

    }

    ngAfterViewInit(): void {
        if(this.viewMode == 'form') {
            this.onHighlight='on';
        }
        this.changeDetection.detectChanges();

        if(this.viewMode == 'audit') {
            if(this.nodeOptions.audit['taskId'][0] == this.blockId) {
                setTimeout( () => {
                    this._diagramService.setAdjustPositionY(document.getElementById(this.blockId));
                }, 300)
            }
        }
        this.formatter();
    }

}
